import { searchService } from '@services';
import { Facet, FacetState } from '../../models';
import { BaseComponent } from '../base.component';

export abstract class BaseFacetComponent extends BaseComponent<Facet> {
    protected override bindEvent = undefined;

    state!: FacetState;

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('input[hawksearch-facet-value]').forEach((e) => {
            e.addEventListener('change', (event: Event) => {
                event.stopPropagation();

                const element = event.currentTarget as HTMLInputElement;
                const field = this.data!.field!;
                const value = element.value;

                if (element.checked) {
                    searchService.addFacetValue(field, value);
                } else {
                    searchService.removeFacetValue(field, value);
                }
            });
        });

        this.shadowRoot?.querySelectorAll('[hawksearch-facet-value]:not(input)').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();
                event.stopPropagation();

                const element = event.currentTarget as HTMLElement;
                const value = element.getAttribute('hawksearch-facet-value');
                const facetValue = this.data!.values?.find((v) => v.value === value);

                if (!facetValue) {
                    return;
                }

                if (facetValue.selected) {
                    searchService.removeFacetValue(this.data!.field!, value!);
                } else {
                    searchService.addFacetValue(this.data!.field!, value!);
                }
            });
        });

        this.shadowRoot?.querySelectorAll('[hawksearch-facet-value-include]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();
                event.stopPropagation();

                const element = event.currentTarget as HTMLElement;
                const field = this.data!.field!;

                let value = element.getAttribute('hawksearch-facet-value-include');

                if (!value) {
                    return;
                }

                value = `@${value}`;

                searchService.removeFacetValue(field, value);
            });
        });

        this.shadowRoot?.querySelectorAll('[hawksearch-facet-value-exclude]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();
                event.stopPropagation();

                const element = event.currentTarget as HTMLElement;
                const field = this.data!.field!;
                const value = element.getAttribute('hawksearch-facet-value-exclude');

                if (!value) {
                    return;
                }

                searchService.excludeFacetValue(field, value);
            });
        });

        this.shadowRoot?.querySelectorAll('[hawksearch-facet-value-toggle]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();
                event.stopPropagation();

                const element = event.currentTarget as HTMLElement;
                const value = element.getAttribute('hawksearch-facet-value-toggle');

                if (!value) {
                    return;
                }

                this.state.values![value].toggled = !this.state.values![value].toggled;

                this.renderContent();
            });
        });

        this.shadowRoot?.querySelectorAll('[hawksearch-facet-toggle]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();
                event.stopPropagation();

                this.state.toggled = !this.state.toggled;

                this.renderContent();
            });
        });
    }
}
